var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Teacher } from '@/models/Teacher';
import { Student } from '@/models/Student';
import { Component, Vue, Prop } from 'vue-property-decorator';
import { avatarHtml } from '@/support/String';
import { Group } from '@/models/Group';
import DataTable from '@/components/data-table/DataTable';
let AddUserDialog = class AddUserDialog extends Vue {
    constructor() {
        super(...arguments);
        this.selectedUsers = [];
        this.users = [];
    }
    mounted() {
        this.initialize();
    }
    initialize() {
        this.users = [];
        if (this.group && this.group.users) {
            this.group.users.forEach((user) => {
                if (user.id) {
                    this.users.push(user.id);
                }
            });
        }
    }
    get tableOptions() {
        return {
            name: {
                singular: this.$tc(`roles.${this.type}`, 1),
                plural: this.$tc(`roles.${this.type}`, 2),
            },
            headers: [
                {
                    text: '',
                    value: 'avatar',
                    transform: avatarHtml,
                },
                { text: this.$t('name.title'), value: 'name' },
            ],
            actions: [],
            filters: [],
            model: this.type === 'teacher' ? new Teacher() : new Student(),
        };
    }
    close() {
        this.$emit('input', false);
    }
    update() {
        this.selectedUsers.forEach((user) => {
            if (!user.id) {
                return;
            }
            if (!this.users.includes(user.id)) {
                this.users.push(user.id);
            }
        });
        if (!this.group) {
            return;
        }
        this.group
            .include(['audit', 'chat', 'users', 'subjects', 'roles', 'parent', 'type'])
            .update({
            users: this.users,
        })
            .then((group) => {
            this.$emit('usersAdded', group);
            this.$emit('input', false);
        })
            .catch((error) => { });
    }
};
__decorate([
    Prop({ default: () => new Group() }),
    __metadata("design:type", typeof (_a = typeof Group !== "undefined" && Group) === "function" ? _a : Object)
], AddUserDialog.prototype, "group", void 0);
__decorate([
    Prop({ default: '' }),
    __metadata("design:type", String)
], AddUserDialog.prototype, "type", void 0);
AddUserDialog = __decorate([
    Component({
        components: {
            DataTable,
        },
    })
], AddUserDialog);
export default AddUserDialog;
